import React from 'react';
import './Praise.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import PromoVideo from '../../Resources/Videos/vanpelts-promo.mp4';

const HOMEADVISOR_URL = 'https://www.homeadvisor.com/rated.VanpeltsTreeService.68135705.html';

// Quoted verbatim from the HomeAdvisor reviews at HOMEADVISOR_URL. Do not reword.
const testimonials = [
    {
        quote: "Andrew was very professional. He came out and did exactly what he said, and showed up when he said he was. My has never looked better, I couldn't be happier with the work that was done. I would recommend his business to anyone who needs this work done. I'm very grateful we found such an excellent pro, an plan to use him any time in the future.",
        rating: '5.0',
        name: 'Phyllis C.',
        location: 'Dayton, OH',
        service: 'Trim or Remove trees and Scrubs',
    },
    {
        quote: "Couldn't ask for better. Fair price. And they did more than I asked without charging extra. Entire crew was courteous and professional. They made quick work of a hard job. They will definitely get my return business, and I would highly recommend them.",
        rating: '5.0',
        name: 'Jennifer D.',
        location: 'Vandalia, OH',
        service: 'Trim or Remove trees and Scrubs',
    },
    {
        quote: "The job took longer than they thought,they had to come out the next day to finish up.They did a very good job.They new about the trees and what could be done without hurting the trees.Our neighbors had them do work for them and they also thought they did a good job.I will definitely refer them to my friends.",
        rating: '5.0',
        name: 'Karen S.',
        location: 'Dayton, OH',
        service: 'Trim Trees',
    },
];

function Praise() {
    return (
        <div className='praise-main'>
            <div className='praise-layout'>
                <div className='praise-header'>
                    Praise from Our Satisfied Clients
                </div>
                {/* Testimonials precede the video in the DOM so the flex row puts the
                    video on the right, and the mobile column stacks it underneath. */}
                <div className='praise-row'>
                    <div className='praise-testimonials'>
                        {testimonials.map((testimonial) => (
                            <div className='praise-praise' key={testimonial.name}>
                                <p className='praise-paragraph'>{testimonial.quote}</p>

                                <div className='customer-data'>
                                    <div className='customer-row'>
                                        <FontAwesomeIcon icon={faStar} className='star-icon' style={{ width: '16px', height: '16px', color: '#384b44' }} />
                                        <div className='customer-rating'>{testimonial.rating}</div>
                                        <p className='customer-name'>{testimonial.name}</p>
                                        <p className='customer-location'>{testimonial.location}</p>
                                    </div>
                                    <div className='customer-service'>{testimonial.service}</div>
                                </div>

                            </div>
                        ))}
                    </div>
                    <div className='praise-video-container'>
                        <video
                            className='praise-video'
                            autoPlay
                            muted
                            loop
                            playsInline
                            controls
                            controlsList='nodownload'
                        >
                            <source src={PromoVideo} type="video/mp4" />
                        </video>
                    </div>
                </div>

                <button className='hook-button customer-margin' onClick={() => {
                    window.open(HOMEADVISOR_URL, '_blank', 'noopener,noreferrer');
                }}>Read More</button>
            </div>
        </div>
    );
}

export default Praise;
